var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ametras-time-field-template',_vm._g(_vm._b({attrs:{"time-format":'HH:mm:ss',"iso-format":'HH:mm:ss'}},'ametras-time-field-template',_vm.attrs$,false),_vm.listeners$))}
var staticRenderFns = []

export { render, staticRenderFns }